export function isJSON(value: string): boolean {
  try {
    JSON.stringify(value);
    return true;
  } catch (error) {
    return false;
  }
}
